import './Login.css'
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie';
import { ErrorNotification, SuccessNotification } from "../../services/Notification";
import HttpRequest from "../../services/Request";

function Login() {
    const navigation = useNavigate();
    const [mobile, setMobile] = useState(null)
    const [pending, setPending] = useState(false)
    const [mobileIsSend, setMobileIsSend] = useState(false)
    const [expirationSeconds, setExpirationSeconds] = useState(0)
    const [code, setCode] = useState('')


    useEffect(() => {
        // exit early when we reach 0
        if (expirationSeconds <= 0) return;


        // save intervalId to clear the interval when the
        // component re-renders
        const intervalId = setInterval(() => {
            setExpirationSeconds(expirationSeconds - 1);
        }, 1000);

        // clear interval on re-render to avoid memory leaks
        return () => clearInterval(intervalId);
        // add expirationSeconds as a dependency to re-rerun the effect
        // when we update it
    }, [expirationSeconds]);

    function formatTime(seconds) {
        let date = new Date(null);
        date.setSeconds(seconds);

        // استفاده از توابع get برای گرفتن ساعت، دقیقه و ثانیه
        let minutes = date.getUTCMinutes();
        let s = date.getUTCSeconds();
        return minutes.toString().padStart(2, '0') + ':' +
            s.toString().padStart(2, '0');
    }

    const sendMobile = async () => {
        if (!mobile) {
            ErrorNotification('موبایل معتبر نیست')
            return;
        }
        setPending(true)
        await HttpRequest(`${process.env.REACT_APP_DOMAIN}/auth/mobile/send`, (res) => {
            setExpirationSeconds(res.data.expiration)
            setMobileIsSend(true)
            SuccessNotification('کد یکبار مصرف مجدد ارسال شد', 'ارسال پیام')
        }, 'post', { mobile })
        setPending(false)
    }
    const sendCode = async () => {
        if (!code) {
            ErrorNotification('کد یکبار مصرف معتبر نیست')
            return;
        }
        setPending(true)
        await HttpRequest(`${process.env.REACT_APP_DOMAIN}/auth/mobile/verify`, async (res) => {
            await Cookies.set('access_token', res.data.access_token)
            await Cookies.set('username', res.data.user.name + ' ' + res.data.user.lastname)
            await Cookies.set('company_name', res.data.user.tournament.company_name)
            await Cookies.set('company_logo', res.data.user.tournament.company_logo)
            navigation('/')
        }, 'post', { mobile, code })
        setPending(false)
    }
    const resetMobile = () => {
        setExpirationSeconds(0);
        setMobileIsSend(false);
    }


    return <div className="h-screen flex items-center justify-center md:justify-normal truncate">
        <div
            className="bg-white default-bg md:basis-10/12 flex md:ps-[15%] md:h-[80%] mx-8 md:ms-[5%] md:me-0 my-8 rounded-xl items-center relative">
            <div className={`w-full md:basis-5/12 lg:basis-4/12 p-5`}>
                <img src='/images/logo.png' className="w-4/6  mx-auto md:hidden" />
                <p className="text-white text-[25px] mt-3 font-bold">ورود به حساب</p>
                <p className="text-white text-[15px] mt-6 font-bold">موبایل</p>
                <div className={`flex ${mobileIsSend ? 'justify-between' : 'justify-center'} items-center mt-3`}>
                    <input type="text" onKeyUp={(e) => setMobile(e.target.value)} disabled={expirationSeconds}
                        className={`w-full placeholder-gray-700 bg-white border-none rounded mt-3 py-4 p-2 transition-all`}
                        placeholder="0912 ..." />
                    {mobileIsSend && <span onClick={resetMobile}
                        className="text-orange text-[12px] px-5 cursor-pointer">ویرایش</span>}
                </div>
                {mobileIsSend &&
                    <>
                        <p className="text-white text-[15px] mt-6 font-bold">کد یکبار مصرف را وارد کنید</p>
                        <div
                            className={`flex ${mobileIsSend ? 'justify-between' : 'justify-center'} items-center mt-3`}>
                            <input type="number" onKeyUp={(e) => setCode(e.target.value)}
                                className={`w-full placeholder-gray-700 bg-white border-none rounded mt-3 py-4 p-2 transition-all`}
                            />
                            {expirationSeconds > 0 &&
                                <span className="text-orange text-[12px] px-5">{formatTime(expirationSeconds)}</span>}
                            {!expirationSeconds &&
                                <span onClick={sendMobile} className="text-orange text-[12px] px-5 cursor-pointer">ارسال مجدد
                                    <img src="/icons/resend-sms.png" className="inline mx-2" alt="" />
                                </span>}
                        </div>
                    </>
                }
                <button onClick={mobileIsSend ? sendCode : sendMobile}
                    disabled={pending}
                    className="#003399 text-center border-none rounded shadow-md font-bold bg-blue py-3 p-2 mt-3 text-[18px] w-full text-white">
                    {pending ? 'در حال ارسال' : 'ارسال'} <img src="/icons/login-btn-icon.png"
                        className="inline mx-3" width="30" alt="" />
                </button>
            </div>
            <img src='/images/login-desktop-logo.png'
                className="h-full hidden md:block md:absolute  translate-x-[-50%] left-0" />
        </div>
    </div>
}

export default Login